<template>
  <div>
    <div class="learning">
      <div class="youtube-loading bg-scroll bg-top bg-center bg-cover"></div>
      <div class="learning-welcome">
        <p class="font-second is-size-4">{{ current }}
      <i class="fas fa-arrow-alt-circle-down " />
          </p>
      </div>
      <div class="media-right"></div>
    </div>
    <div ref="courses" class="courses-wrapper">
      <h1 class="courses-title font-second--bold is-size-2 is-size-4-mobile">
        Courses offered for {{current}} <br/>
        (Beginning January 8)
        <p class="is-size-6 font-main">
          *Courses marked with <span class="font-hebrew lang-id">א</span> are
          Hebrew courses and courses marked with
          <span class="font-hebrew lang-id">α</span> are Greek courses. All times are Eastern Standard Time.
        </p>
        <p class="is-size-6 font-main"></p>
      </h1>
      <div class="courses section container">
        <div
          class="media course"
          v-for="(course, ci) in semesters[current]"
          :key="ci"
        >
          <div v-if="course.lang" class="lang-id font-hebrew">
            {{ course.lang }}
          </div>
          <div class="media-left"></div>
          <div class="media-content">
            <div class="content">
              <p class="is-size-4 font-second--bold">
                {{ course.title }}
              </p>
              <p class="font-main">
                {{ course.description }}
              </p>
              <p class="font-main">
                Instructor: {{ course.instructor }}
              </p>
              <p class="font-main">
                {{ course.time }}
              </p>
              <p class="rf-button  font-main">
                <a
                  :href="syllabusURL(current, course.syllabus)"
                  target="_blank"
                >
                  Download Syllabus
                </a>
              </p>
            </div>
          </div>
          <div class="media-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import semesters from './semester.js'
export default {
  name: 'Learning',
  data() {
    return {
      semesters: semesters,
      current: 'Winter 2024',
    }
  },
  methods: {
    scrollView(element) {
      this.$refs[element].scrollIntoView({ behavior: 'smooth' })
    },
    syllabusURL: (semester, filename) => {
      return `http://syllabus.russelltfuller.com/${semester
        .toLowerCase()
        .split(' ')
        .join('')}/${filename}`
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_colors.scss';
.learning {
  position: relative;
  height: 100vh;
  width: 100vw;
  .cover-bar {
    position: absolute;
    height: 5em;
    width: 100vw;
    background-color: black;
    left: 0;
    z-index: 10;
    &--top {
      @extend .cover-bar;
      top: 0;
    }
    &--bottom {
      @extend .cover-bar;
      bottom: 0;
    }
  }
  & > .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(2, 0, 36, 0.5) 0%,
      rgba(2, 0, 36, 0.3) 100%
    );
  }
  .youtube-loading {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: opacity 0.4s linear;
    background-image: linear-gradient(
        to bottom,
        rgba(2, 0, 36, 0) 0%,
        rgba(2, 0, 36, 0.3) 100%
      ),
      url('../assets/Fuller_alt.jpg');
    &.ready {
      opacity: 0;
    }
  }
  .learning-welcome {
    position: absolute;
    bottom: 2em;
    left: 5%;
    width: 100%;
    z-index: 10;
    color: white;
    & > .welcome-title {
      width: 45%;
    }
    & > .welcome-button {
      width: 100%;
      & > button {
        display: inline;
        outline: none;
        border: 1px solid white;
        width: 10em;
        padding: 6px 3px;
        text-align: center;
        margin-top: 2em;
        margin-right: 1em;
        transition: all 0.1s ease;
        &:hover {
          /* background-color: #9f9eb0; */
          background-color: white;
          color: black;
        }
      }
    }
  }
}
.courses-overview {
  width: 100vw;
  padding: 10% 0;
  & > .courses-title {
    width: 80%;
    margin: 0 auto;
    letter-spacing: 2px;
  }
  & > .description {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 2em;
  }
}
.courses-wrapper {
  background-color: rgba($primary, 0.9);
  padding: 10em 0;
  & > .courses-title {
    width: 90%;
    margin: 0 auto;
    letter-spacing: 2px;
    color: white;
    & > p {
      & > .lang-id {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 2em;
        width: 2em;
        border-radius: 50%;
        border: 1px solid white;
        background-color: $primary;
        color: white;
      }
    }
  }
  & > .courses {
    & > .course {
      position: relative;
      border: 1px solid $primary;
      background-color: white;
      color: $primary;
      padding-top: 2em;
      padding-bottom: 2em;
      & > .lang-id {
        position: absolute;
        top: -0.8em;
        left: -0.8em;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2em;
        width: 2em;
        z-index: 3;
        border-radius: 50%;
        border: 1px solid white;
        background-color: $primary;
        color: white;
      }
      & > .download {
        position: absolute;
        bottom: 12px;
        left: 10%;
        width: 80%;
      }
    }
  }
}
.overview-button {
  padding: 4% 0 !important;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  99% {
    opacity: 0.01;
    width: 100%;
    height: 100%;
  }
  100% {
    opacity: 0;
    width: 0;
    height: 0;
  }
}
</style>
